import React from 'react';
import PropTypes from 'prop-types';
import cl from 'classnames';
import TrayItem from '~/shared/components/TrayItem';
import SelectorList from '~/shared/components/SelectorList';
import {getColor, getViewImage} from '~/utils/catalog';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
function YourItems(props) {
  const {
    attemptFireNoSleeveImagesTag,
    disabled,
    isSleeveDecoEligible,
    items,
    onDelete,
    onSelect,
    selectedItemIndex
  } = props;

  const handleTrayItemClick = ({selection}) => {
    onSelect(selection.colorId);

    if (isSleeveDecoEligible && attemptFireNoSleeveImagesTag) {
      attemptFireNoSleeveImagesTag();
    }
  };

  return (
    <SelectorList
      options={items}
      renderOption={({selection, style, color}) => {
        if (!style?.colors || !color || !selection) {
          return null;
        }
        const handleClick = e => {
          e.stopPropagation();
          onDelete({colorId: selection.colorId});
        };
        const handleDelete = !disabled && items.length > 1 ? handleClick : null;
        const viewImage = getViewImage(
          getColor(style, selection.colorId),
          'front'
        );
        const trayClasses = cl({'is-disabled': disabled});
        return (
          <TrayItem
            className={trayClasses}
            imageDefinition={viewImage}
            productId={selection.colorId}
            styleId={style.id}
            title={`${style.name} ${color.name}`}
            onDeleteClick={handleDelete}
          />
        );
      }}
      selectedIndex={selectedItemIndex}
      onChange={!disabled ? handleTrayItemClick : undefined}
    />
  );
}

YourItems.displayName = 'YourItems';

const propTypes = {
  attemptFireNoSleeveImagesTag: PropTypes.func,
  disabled: PropTypes.bool,
  isSleeveDecoEligible: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      selection: PropTypes.object,
      style: PropTypes.object
    })
  ),
  selectedItemIndex: PropTypes.number,
  onDelete: PropTypes.func,
  onSelect: PropTypes.func
};

YourItems.propTypes = propTypes;

export default YourItems;
